<template>
	<el-dialog title="添加司机" v-model="isAdd" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>司机名称</span>
						</div>
						<el-input v-model="driName" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>身份证号:</span>
						</div>
						<el-input v-model="driCardid" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>手机号:</span>
						</div>
						<el-input v-model="driPhone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>性别:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="driSex" placeholder="性别">
								<el-option label="男" value="0" />
								<el-option label="女" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系人:</span>
						</div>
						<el-input v-model="driEmcontact" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系电话:</span>
						</div>
						<el-input v-model="driEmphone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>居住地址:</span>
						</div>
						<el-input v-model="driHabitancy" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>类型:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="driType" placeholder="性别">
								<el-option label="加盟" value="0" />
								<el-option label="外调" value="1" />
								<el-option label="临时" value="2" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="driRemark" class="platItemRigth" placeholder="请输入" />
					</div>

				</div>
			</div>
			<p class="platTitle">驾驶证信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证号</span>
							</div>
							<el-input v-model="drilLicenseId" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证档案编号</span>
							</div>
							<el-input v-model="drilArchiveNo" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证发证机关</span>
							</div>
							<el-input v-model="drilInstitutionSeal" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证发证日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilIssueDate" type="date" :clearable="false"
									placeholder="请选择驾驶证发证日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证起始日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilStartDate" type="date" :clearable="false"
									placeholder="请选择驾驶证起始日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证到期日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilEndDate" type="date" :clearable="false"
									placeholder="请选择驾驶证到期日期">
								</el-date-picker>
							</div>
						</div>
					</div>
					<div class="w50 platItem flex" style="align-items: flex-start">
						<div class="flex flex-y-center platItemLeft">
							<span>驾驶证照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth" v-if="pageType != 'detail'">
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploaddrilPhotoUrl" accept=".jpg,.jpeg,.png">
								<div class="upRpic_icon_item2" v-if="drilPhotoUrl == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :src="drilPhotoUrl" />
								</div>
							</el-upload>
						</div>
					</div>
				</div>
			</div>
			<p class="platTitle">从业资格证信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证编号</span>
							</div>
							<el-input v-model="drjcNo" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>从业日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcJobDate" type="date" :clearable="false"
									placeholder="请选择从业日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证发证日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcStartDate" type="date" :clearable="false"
									placeholder="请选择资格证发证日">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证到期日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcEndDate" type="date" :clearable="false"
									placeholder="请选择资格证到期日">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>道路经营许可证号</span>
							</div>
							<el-input v-model="drjcTransportLicense" class="platItemRigth" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 platItem flex" style="align-items: flex-start">
						<div class="flex flex-y-center platItemLeft">

							<span>从业资格证照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth" v-if="pageType != 'detail'">
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploaddrjcPhotoUrl" accept=".jpg,.jpeg,.png">
								<div class="upRpic_icon_item2" v-if="drjcPhotoUrl == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :src="drjcPhotoUrl" />
								</div>
							</el-upload>
						</div>
					</div>
				</div>
			</div>
			<!-- <p class="platTitle">银行卡信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>开户银行</span>
							</div>
							<el-input :disabled="pageType == 'detail' ? true : false" v-model="bcBank"
								class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>开户支行</span>
							</div>
							<el-input :disabled="pageType == 'detail' ? true : false" v-model="bcBankBranch"
								class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>银行卡号</span>
							</div>
							<el-input :disabled="pageType == 'detail' ? true : false" v-model="bcNo"
								class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>持卡人名</span>
							</div>
							<el-input :disabled="pageType == 'detail' ? true : false" v-model="bcName"
								class="platItemRigth" placeholder="请输入" />
						</div>

						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>所在区域</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<div style="width: 50%">
									<el-select v-model="bcProvince" placeholder="请选择省"
										:disabled="pageType == 'detail' ? true : false">
										<el-option v-for="item in bcProvinceList" :key="item.code" :label="item.name"
											:value="item.code" />
									</el-select>
								</div>
								<div style="width: 50%">
									<el-select v-model="bcCity" placeholder="请选择市"
										:disabled="pageType == 'detail' ? true : false" class="mar-left-20">
										<el-option v-for="item in bcCityList" :key="item.code" :label="item.name"
											:value="item.code" />
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="w50">
						<div class="platItem flex" style="align-items: flex-start">
							<div class="flex flex-y-center platItemLeft">
								<span>银行卡照</span>
							</div>
							<div class="flex flex-y-center flex-x-between platItemRigth" v-if="pageType != 'detail'">
								<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
									:on-change="
                      (value) => {
                        uploadPic(value, 'bcPicFront');
                      }
                    " accept=".jpg,.jpeg,.png">
									<img v-if="!bcPicFront" src="@/assets/images/icon-bankcard.png" alt="" srcset="" />
									<img v-else :src="bcPicFront" alt="" srcset="" />
								</el-upload>
								<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
									:on-change="
                      (value) => {
                        uploadPic(value, 'bcPicBack');
                      }
                    " accept=".jpg,.jpeg,.png">
									<img v-if="!bcPicBack" src="@/assets/images/icon-bankcard1.png" alt="" srcset="" />
									<img v-else :src="bcPicBack" alt="" srcset="" />
								</el-upload>
							</div>
							<div class="flex flex-y-center flex-x-between platItemRigth" v-else>
								<img v-if="!bcPicFront" src="@/assets/images/icon-bankcard.png" alt="" srcset="" />
								<img v-else :src="bcPicFront" alt="" srcset="" />
								<img v-if="!bcPicBack" src="@/assets/images/icon-bankcard1.png" alt="" srcset="" />
								<img v-else :src="bcPicBack" alt="" srcset="" />
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<span class="dialog-footer">
				<template v-if="pageType != 'detail'">
					<span class="btn btn-outline-default" v-on:click="closeModal()">取消</span>
					<span class="btn bg-default ml-50" v-on:click="submit()">确定</span>
				</template>
				<template v-else>
					<span class="btn bg-default" v-on:click="closeModal()">关闭</span>
				</template>
			</span>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";

	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	import * as imageConversion from "image-conversion";
	export default defineComponent({
		name: "Add",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {});
			});
			const data = reactive({
				isAdd: false,
				treeData: [],
				roleList: [],
				defaultProps: {
					children: "children",
					label: "text",
				},
				valueTitle: "",
				isShowTree: false,

				driOrg: "2", //所属机构
				driOrgUsing: "0", //机构级别 0本机构1本级及下级2本级及下级所有
				driCardid: "", //身份证号
				driName: "", //司机名称
				driPhone: "", //手机号
				driType: "0", //司机类型0加盟1外调2临时
				driDriveType: "2", //准驾车型
				driSex: "0", //性别0男1女
				driSaler: "2", //招商顾问
				driSource: "2", //信息来源
				driIntention: "2", //意向程度0高1中2低3无意向
				driWeixin: "", //微信号
				driEmcontact: "", //紧急联系人
				driEmphone: "", //紧急联系电话
				driHabitancy: "", //居住地
				driRemark: "", //备注
				drjcNo: "", //从业资格证编号
				drjcJobDate: "", //从业日期
				drjcStartDate: "", //从业资格证发证日
				drjcEndDate: "", //从业资格证到期日
				drjcTransportLicense: "", //道路经营许可证
				drjcPhotoUrl: "", //从业资格证图片
				drilLicenseId: "", //驾驶证号
				drilArchiveNo: "", //驾驶证档案编号
				drilInstitutionSeal: "", //驾驶证发证机关
				drilIssueDate: "", //初次领证日期
				drilStartDate: "", //驾驶证起始日期
				drilEndDate: "", //驾驶证到期日期
				drilPhotoUrl: "", //驾驶证照片

				dataItem: {
					userLgname: "", //角色账号
					userNickname: "", //角色名
					userHeadImg: "", //头像
					userPhone: "", //手机号
					userCardid: "", //身份证
					roleList: [], //选中的角色id
					roleNames: [], //选中的角色名字
					userState: true, //用户状态 0正常 1禁用
					userStatus: 0,
					deptNo: "",

				},
			});
			//重置数据
			const init = () => {
				data.isAdd = true;
				data.dataItem.userLgname = ''
				data.dataItem.userNickname = ''
				data.dataItem.userHeadImg = ''
				data.dataItem.userPhone = ''
				data.dataItem.userCardid = ''
				data.dataItem.roleList = []
				data.dataItem.roleNames = []
				data.dataItem.userState = true
				data.dataItem.userStatus = 0
				data.dataItem.deptNo = ''

				data.driOrg = "2"; //所属机构
				data.driOrgUsing = "0"; //机构级别 0本机构1本级及下级2本级及下级所有
				data.driCardid = ""; //身份证号
				data.driName = ""; //司机名称
				data.driPhone = ""; //手机号
				data.driType = "0"; //司机类型0加盟1外调2临时
				data.driDriveType = "2"; //准驾车型
				data.driSex = "0"; //性别0男1女
				data.driSaler = "2"; //招商顾问
				data.driSource = "2"; //信息来源
				data.driIntention = "2"; //意向程度0高1中2低3无意向
				data.driWeixin = ""; //微信号
				data.driEmcontact = ""; //紧急联系人
				data.driEmphone = ""; //紧急联系电话
				data.driHabitancy = ""; //居住地
				data.driRemark = ""; //备注
				data.drjcNo = ""; //从业资格证编号
				data.drjcJobDate = ""; //从业日期
				data.drjcStartDate = ""; //从业资格证发证日
				data.drjcEndDate = ""; //从业资格证到期日
				data.drjcTransportLicense = ""; //道路经营许可证
				data.drjcPhotoUrl = ""; //从业资格证图片
				data.drilLicenseId = ""; //驾驶证号
				data.drilArchiveNo = ""; //驾驶证档案编号
				data.drilInstitutionSeal = ""; //驾驶证发证机关
				data.drilIssueDate = ""; //初次领证日期
				data.drilStartDate = ""; //驾驶证起始日期
				data.drilEndDate = ""; //驾驶证到期日期
				data.drilPhotoUrl = ""; //驾驶证照片

			};


			const dialogClosedHandle = () => {
				data.isAdd = false;
			};
			const closeModal = () => {
				data.isAdd = false;
			};
			const submit = async () => {


				if (data.driName == "") {
					proxy.$message.error("请填写司机名称");
					return;
				}
				if (data.driPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}

				let params = {
					driOrg: data.driOrg,
					driOrgUsing: data.driOrgUsing,
					driCardid: data.driCardid,
					driName: data.driName,
					driPhone: data.driPhone,
					driType: data.driType,
					driDriveType: data.driDriveType,
					driSex: data.driSex,
					driSaler: data.driSaler,
					driSource: data.driSource,
					driIntention: data.driIntention,
					driWeixin: data.driWeixin,
					driEmcontact: data.driEmcontact,
					driEmphone: data.driEmphone,
					driHabitancy: data.driHabitancy,
					driRemark: data.driRemark,
					driJobCertificate: {
						drjcNo: data.drjcNo,
						drjcJobDate: data.drjcJobDate,
						drjcStartDate: data.drjcStartDate,
						drjcEndDate: data.drjcEndDate,
						drjcTransportLicense: data.drjcTransportLicense,
						drjcPhotoUrl: data.drjcPhotoUrl
					},
					driLicense: {
						drilLicenseId: data.drilLicenseId,
						drilArchiveNo: data.drilArchiveNo,
						drilInstitutionSeal: data.drilInstitutionSeal,
						drilIssueDate: data.drilIssueDate,
						drilStartDate: data.drilStartDate,
						drilEndDate: data.drilEndDate,
						drilPhotoUrl: data.drilPhotoUrl
					}
				}

				const r = await proxy.$http.post(apiObj.driSave, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isAdd = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};
			
			// 上传驾驶证图片
			const uploaddrilPhotoUrl = (file) => {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					imageConversion.compress(file.raw, 0.6).then((res) => {
						imgFileToBase64({
							raw: res
						}, (imageUrl) => {
							data.drilPhotoUrl = imageUrl;
						});
					});
				} else {
					imgFileToBase64(file, (imageUrl) => {
						data.drilPhotoUrl = imageUrl;
					});
				}
			};
			
			// 上传从业资格图片
			const uploaddrjcPhotoUrl = (file) => {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					imageConversion.compress(file.raw, 0.6).then((res) => {
						imgFileToBase64({
							raw: res
						}, (imageUrl) => {
							data.drjcPhotoUrl = imageUrl;
						});
					});
				} else {
					imgFileToBase64(file, (imageUrl) => {
						data.drjcPhotoUrl = imageUrl;
					});
				}
			};

			
			const closeTree = () => {
				data.isShowTree = false
			}
			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				closeTree,
				uploaddrilPhotoUrl,
				uploaddrjcPhotoUrl
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 70%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 70%;
		padding-left: 20px;
		box-sizing: border-box;
	}

/* 	.platItemRigth img {
		width: 190px;
		height: 130px;
	} */

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
	
	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 60px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}
	
	.upRpic_icon_item2 {
		margin-top: 0px;
		width: 190px;
		height: 130px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}
	
	.upRpic2_icon {
		/* width: 125px;
		height: 125px; */
		width: 100%;
		hieght: auto;
	}
	
	.upRpic_icon {
		width: 20px;
		height: 20px;
	}
</style>